import { render } from "./NewsItem.vue?vue&type=template&id=25fac0ea&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import "./NewsItem.vue?vue&type=style&index=0&id=25fac0ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25fac0ea"

export default script